<template>
  <EZRackLogo/>
</template>
<script>
import EZRackLogo from '@/pages/Dashboard/EZRackLogo.vue'

export default {
  name: "UserDashboard",
  components: {
    EZRackLogo
  },
  setup() {
    return {}
  },
}
</script>
